import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type TeamMessageAdapter from 'uplisting-frontend/adapters/team-message';

export const THREAD_PAGE_SIZE = 50;

export default class TeamMessageRepositoryService extends BaseRepositoryService<
  ModelRegistry['team-message']
> {
  recordName = 'team-message';
  implementMethods = ['query', 'createRecord', 'save'];

  public async forConversation(
    conversation: ModelRegistry['team-conversation'],
  ): Promise<ModelRegistry['team-message'][]> {
    const messages = await this.query({
      team_conversation_id: conversation.id,
      per_page: THREAD_PAGE_SIZE,
    });

    return messages.slice();
  }

  // The API tombstones a removed message rather than deleting it, so the record stays in the
  // store and is marked removed locally; destroying it would drop the placeholder and throw on
  // any later write to the record.
  public async remove(message: ModelRegistry['team-message']): Promise<void> {
    try {
      const adapter = this.store.adapterFor(
        'team-message',
      ) as TeamMessageAdapter;

      await adapter.remove(message.id);

      this.store.push({
        data: {
          id: message.id,
          type: 'team-message',
          attributes: { deleted: true, deletedAt: new Date(), body: null },
        },
      });
    } catch (err) {
      this.sentry.captureException(err, {
        tags: { repository: this.recordName, operation: 'remove' },
      });

      throw err;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/team-message': TeamMessageRepositoryService;
  }
}
